import { useFetchEmail } from "../../../fetch/fetch.authentication.ts";

const CurrentEmail = () => {
  const { email, isLoading, isError } = useFetchEmail("loading@wait.now");
  if (isLoading) return email;
  if (isError) return isError.message;
  return email;
};
export default CurrentEmail;
